import React from 'react'
import { Link } from 'react-router-dom';
import Button from '../Components/Button';
import useChangeTitle from "../Hooks/useChangeTitle.jsx";

export default function NotFound() {
  useChangeTitle("404 Page not found");
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="text-center">
        <h1 className="text-9xl font-bold text-blue-600 mb-4">404</h1>
        <h2 className="text-4xl font-bold text-gray-800 mb-4">Page Not Found</h2>
        <p className="text-xl text-gray-600 mb-8">
          The page you're looking for doesn't exist or has been moved.
        </p>
        <div className="space-x-4">
          <Link to="/">
            <Button>Go Home</Button>
          </Link>
          <Link to="/contact-us">
            <Button outline={true}>Contact Us</Button>
          </Link>
        </div>
      </div>
    </div>
  )
}
